import { render, staticRenderFns } from "./ArticlesOverviewEditing.vue?vue&type=template&id=bdf8d576&scoped=true"
import script from "./ArticlesOverviewEditing.vue?vue&type=script&lang=js"
export * from "./ArticlesOverviewEditing.vue?vue&type=script&lang=js"
import style0 from "./ArticlesOverviewEditing.vue?vue&type=style&index=0&id=bdf8d576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf8d576",
  null
  
)

export default component.exports